import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { en } from '$shared/i18n/translations';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    resources: {
      en,
    },
    interpolation: {
      // react already saves from xss
      escapeValue: false,
    },
  });

export default i18next;
